import { number, object, string } from 'yup';
import { CreateCommand } from '../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../enums.js';

const SCHEMA = object({
  id: string().required(),
  type: string().oneOf(['database_import_records']).required(),
  status: string().oneOf(['completed', 'failed', 'in_progress', 'pending']).required(),
  output_file_key: string().required().default(null).nullable(),
  success_count: number().required().integer().default(0),
  failure_count: number().required().integer().default(0),
  total_count: number().required().integer().default(0),
});

/**
 * BulkActionUpdateEvent
 *
 * - Evento emitido quando uma ação em massa é atualizada.
 */
export class BulkActionUpdateEvent extends CreateCommand(
  RealtimeEventType.BulkActionUpdate,
  SCHEMA,
) {}
